import React from 'react';
import { DescriptionsProps } from 'antd';

import { StyledAntdDescriptions } from './style';

const CVDescriptions = (props: DescriptionsProps): JSX.Element => (
  <StyledAntdDescriptions {...props} />
);

CVDescriptions.Item = StyledAntdDescriptions.Item;

export default CVDescriptions;
